// src/utils/bootstrap.ts
// This file provides a properly typed import of Bootstrap for TypeScript

// Import the Bootstrap module and export it
import * as bootstrap from "bootstrap";

// Export default for easy importing
export default bootstrap;

// Also export named imports if needed for specific components
export const Modal = bootstrap.Modal;
export const Toast = bootstrap.Toast;
export const Offcanvas = bootstrap.Offcanvas;
export const Collapse = bootstrap.Collapse;
export const Dropdown = bootstrap.Dropdown;
export const Popover = bootstrap.Popover;
